import { Badge, Box, Group, Text } from "@mantine/core";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetMcbimSingleMcbimSpaceQuery, useGetMultiplacerSingleRoomQuery } from "../../../openapi";
import { useAppSelector } from "../../app/hooks";
import { MmiBadge } from "../../components/MmiBadge";
import { selectHttpSingleRoomFull } from "../../Room/httpRoomSelectors";
import StandardRoomItemsTable from "./StandardRoomItemsTable";
import StandardRoomViewer from "./StandardRoomViewer";
import {
  selectActiveStandardRoomArgs,
  selectActiveStandardRoomCeilingHeightAboveFloorMm,
  selectActiveStandardRoomItemsWithCategories,
  selectActiveStandardRoomName,
  selectActiveStandardRoomMmi,
  selectActiveStandardRoomMcbimSpaceArgs,
  selectCachedActiveStandardRoom,
  selectCachedActiveStandardRoomMcbimSpace,
} from "./standardroomSelectors";

const StandardRoom = () => {
  const activeStandardRoomName = useAppSelector(selectActiveStandardRoomName);
  const activeStandardRoomArgs = useAppSelector(selectActiveStandardRoomArgs);
  const mcbimStandardSpaceArgs = useAppSelector(selectActiveStandardRoomMcbimSpaceArgs);
  const standardRoom = useAppSelector(selectCachedActiveStandardRoom);
  const mcbimSpaceStandardRoom = useAppSelector(selectCachedActiveStandardRoomMcbimSpace);
  const activeStandardRoomMmi = useAppSelector(selectActiveStandardRoomMmi);
  const activeStandardRoomCeilingHeight = useAppSelector(selectActiveStandardRoomCeilingHeightAboveFloorMm);
  const standardRoomItems = useAppSelector(selectActiveStandardRoomItemsWithCategories);
  const room = useAppSelector(selectHttpSingleRoomFull);

  useGetMultiplacerSingleRoomQuery(activeStandardRoomArgs ?? skipToken);
  useGetMcbimSingleMcbimSpaceQuery(mcbimStandardSpaceArgs ?? skipToken);

  return (
    <Box h="100%" style={{ display: "flex", flexDirection: "column", minHeight: 0 }}>
      <Box
        px="md"
        py="xs"
        bg="blue.0"
        style={{
          borderTop: "1px solid rgba(15, 23, 42, 0.08)",
          borderBottom: "1px solid rgba(15, 23, 42, 0.12)",
          boxShadow: "inset 0 -1px 0 rgba(255, 255, 255, 0.45)",
        }}
      >
        <Group justify="space-between" align="center" gap="xs" wrap="nowrap">
          <Box style={{ minWidth: 0 }}>
            <Text size="10px" fw={700} c="blue.7" tt="uppercase">
              Standardrom
            </Text>
            <Text c="black" size="sm" fw={600} lineClamp={1}>
              {mcbimSpaceStandardRoom?.name ?? activeStandardRoomName ?? "Ukjent standardrom"}
            </Text>
            <Text size="xs" c="dimmed" lineClamp={1}>
              {mcbimSpaceStandardRoom?.longName ?? "Mangler beskrivelse"}
            </Text>
          </Box>

          <Group gap={6} wrap="nowrap">
            {activeStandardRoomMmi != null && <MmiBadge value={activeStandardRoomMmi} />}
            {activeStandardRoomCeilingHeight != null && (
              <Badge color="gray" variant="light" radius="sm">
                H: {activeStandardRoomCeilingHeight}
              </Badge>
            )}
            <Badge color="blue" variant="light" radius="sm">
              {standardRoom?.rfpStatus ?? room?.rfpStatus ?? "Ingen status"}
            </Badge>
          </Group>
        </Group>
      </Box>

      <Box style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
        <Box style={{ flex: "1 1 50%", minHeight: 0, overflow: "hidden" }}>
          <StandardRoomViewer />
        </Box>
        <Box style={{ flex: "1 1 50%", minHeight: 0, overflow: "hidden", display: "flex" }}>
          <StandardRoomItemsTable items={standardRoomItems} />
        </Box>
      </Box>
    </Box>
  );
};

export default StandardRoom;
